import { SVGProps } from "react";

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M4.50001 0.142012C4.30888 -0.0473372 3.99032 -0.0473372 3.79919 0.142012C3.60806 0.331361 3.60806 0.646943 3.79919 0.836292L11.0064 7.97633L3.74344 15.1637C3.55231 15.3531 3.55231 15.6686 3.74344 15.858C3.83901 15.9527 3.96643 16 4.09385 16C4.22127 16 4.34869 15.9527 4.44426 15.858L12.4001 7.97633L4.50001 0.142012Z" />
  </svg>
);
